import {DISALLOWED_EMAILS, ERROR_MSGS, TLDS, TLD_S3_PATH_CONFIG, MAX_PDF_SIZE, MAX_FILE_SIZE} from "../constants";
import {FILE_TYPE_PDF} from "../components/SelectedFile";

export function isPDF(file) {
  return file.type === FILE_TYPE_PDF
}

const convertToBytes = (size) => 1024 * 1024 * size

export function isValidFileSize(file, maxSize) {
  if (maxSize) {
    return file.size < convertToBytes(maxSize)
  } else if (file.type === FILE_TYPE_PDF) {
    return file.size < convertToBytes(MAX_PDF_SIZE)
  } else return file.size < convertToBytes(MAX_FILE_SIZE);
}

export const pluralize = (singular, plural, count) => count === 1 ? singular : plural;

export const copyToClipboard = (text) => {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
}

export const getDirectFileLink = (root, filename, ext, dateCreated) => {
  if (!filename)
    return null
  else
    return `${root}/${filename.replace(`.${ext}`, '')}-${dateCreated.replace(/:|\\./g, '-')}.${ext}`
}

export const validateDisallowedEmails = (email) => !DISALLOWED_EMAILS.some(e => email.match(`${e}$`)) && !email.includes('+');

export const getErrorMessage = (err) => {
    if (err && err.response && err.response.data && err.response.data.code) {
        return ERROR_MSGS[err.response.data.code]
    }
    return undefined;
}

export const isDevSite = () => window.location.hostname.includes('.tiiny.site') || window.location.hostname === 'localhost'

export const mbValue = (mb) => 1024 * 1024 * mb

export const isTrialAccount = ({ productId }) => !productId;

export const isMac = () => navigator?.platform?.toUpperCase().indexOf('MAC') > -1

export function hashString(str = '') {
    let hash = 0, i, chr;
    if (str?.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
}

export const getTLDs = ({account}) => {
    //if(isDevSite()) return [TLDS.TIINY_CO_UK]
  debugger;
    return account?.validated ? [TLDS.TIINY_CO, TLDS.TIINY_SITE] : [TLDS.TIINY_SITE]
}

export const getSubdomainAndTLD = ({ site }) => {
  const { subdomain } = site
  const splitSubdomain = subdomain?.split('.')
  return splitSubdomain ? { subdomain: splitSubdomain[0], tld: `.${splitSubdomain.slice(1).join('.')}` } : {}
}

export const getS3Path = ({ site, isCustomDomain }) => {
  const { subdomain, tld } = getSubdomainAndTLD({ site })
  return isCustomDomain ? `${tld.substring(1)}/${subdomain}` : TLD_S3_PATH_CONFIG[tld]({ subdomain, tld })
}